import React, { useEffect, useState, useLayoutEffect } from "react";
import PageTitle from "../banner";
import ReactImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // Don't forget to import the styles

function About(props) {
  const getInitialBgImage = () =>
    window.innerWidth <= 768
      ? "img/about/aboutMobile.jpg"
      : "img/about/banner02.jpg";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(getInitialBgImage);
  const [isOpen, setIsOpen] = useState(false); // For lightbox modal

  useLayoutEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/aboutMobile.jpg"
          : "img/about/banner02.jpg"
      );
      setIsMobile(window.innerWidth <= 768);
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const teamMembers = [
    {
      name: "IAAP Certified",
      role: "Chitrachintaa Bangla",
      imgSrc: "img/team/01.jpeg",
    },
    {
      name: "IAAP Certified",
      role: "Chitrachintaa Bangla",
      imgSrc: "img/team/02.jpeg",
    },
    {
      name: "KPA National Salon",
      role: "KPA®",
      imgSrc: "img/team/13.jpeg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/04.jpeg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/05.jpeg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/06.jpeg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/07.jpeg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/08.jpeg",
    },
    {
      name: "Royal Bengal Art",
      role: "FIP & FIAP",
      imgSrc: "img/team/09.jpeg",
    },
    {
      name: "Royal Bengal Art",
      role: "FIP & FIAP",
      imgSrc: "img/team/10.jpeg",
    },

    {
      name: "IWPC&E",
      role: "Alva’s Virasat",
      imgSrc: "img/team/11.jpg",
    },
    {
      name: "CWENC 2024",
      role: "IFP&GHPC",
      imgSrc: "img/team/03.jpg",
    },
    // {
    //   name: "All India Digital Salon – 2024",
    //   role: "Madras Photography Society",
    //   imgSrc: "img/team/12.jpeg",
    // },
  ];

  const [currentImage, setCurrentImage] = useState(""); // Track the current image for modal

  const openModal = (imgSrc) => {
    setCurrentImage(imgSrc);
    setIsOpen(true);
  };

  return (
    <div>
      <div style={{ marginBottom: "0.1rem" }}>
        <PageTitle desc={"About"} img={bgImage} />
      </div>

      <section className="about-section" style={{ marginTop: "4rem" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-md-4 p-0">
              <div
                className="about-pic set-bg"
                style={{
                  backgroundImage: "url(img/about/nagesh.jpg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain", // Image fits inside container
                  backgroundPosition: "center", // Center the image in the container
                  height: "629px",
                }}
              ></div>
            </div>

            <div
              className="col-lg-8 col-md-8"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div className="about-text">
                <div style={{ padding: "0rem 1.5rem 0rem 0rem" }}>
                  <h4>
                    A Photographer's Odyssey: From Market Research to Masterful
                    Photography
                  </h4>
                  <p
                    style={{
                      fontSize: "14px",
                      marginTop: "1rem",
                      textAlign: "justify",
                    }}
                  >
                    I am Nagesh Murthy, As a passionate photographer based in
                    Bangalore, India, I’ve been captivated by the world’s beauty
                    for decades. My lens has been my constant companion,
                    capturing life’s most fleeting moments and transforming them
                    into timeless memories. With a particular passion for
                    wildlife and bird photography, I've spent countless hours
                    immersed in nature, observing and documenting the intricate
                    details of the natural world.
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                    }}
                  >
                    My journey into the world of photography has been shaped by
                    the guidance of several inspiring mentors. Their expertise
                    and encouragement have been invaluable in honing my skills
                    and expanding my knowledge. I’ve also had the privilege of
                    connecting with like-minded photographers who share my
                    passion for capturing the beauty of the natural world. These
                    friendships have fostered a sense of camaraderie and
                    provided opportunities for collaborative projects and
                    knowledge sharing.
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                    }}
                  >
                    One of the most rewarding aspects of wildlife photography is
                    the opportunity to work with skilled guides and trackers.
                    These individuals possess an intimate knowledge of the
                    wilderness and its inhabitants. Their expertise has been
                    instrumental in helping me locate and photograph elusive
                    subjects. I’m grateful for their dedication and unwavering
                    support, which have allowed me to capture some of my most
                    iconic images.
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                    }}
                  >
                    Behind every successful photographer is a supportive family.
                    My family has always been my biggest cheerleaders,
                    encouraging me to pursue my passion and providing unwavering
                    support. Their love and understanding have been essential in
                    helping me balance my personal and professional life.
                  </p>

                  <p
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                    }}
                  >
                    I invite you to explore my portfolio and discover the magic
                    of the moment. Let’s embark on a visual journey together,
                    where every image tells a story.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="team-section spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 d-flex">
              <div className="section-title">
                <h2>Recognitions </h2>
                <p>
                  My work has been recognized with several awards. My images
                  have been featured in prestigious publications and
                  exhibitions, captivating audiences globally.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {teamMembers.map((member, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-6 d-flex">
                <div className="team-item">
                  <img
                    src={member.imgSrc}
                    alt={member.name}
                    onClick={(e) => {
                      e.preventDefault();
                      openModal(member.imgSrc);
                    }}
                  />
                  <div className="ti-text">
                    <h5>{member.name}</h5>
                    <span>{member.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="cta-section spad set-bg"
        style={{
          backgroundImage: "url(img/about/about.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          height: "80vh",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-text">
                <h3 style={{ color: "whitesmoke" }}>
                  Photography is the art of frozen time... the ability to
                  capture a moment that’s gone forever, impossible to reproduce
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="testimonial-section spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>What client say?</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod
                  <br /> tempor incididunt ut labore et dolore.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                <div className="testimonial-item">
                  <div className="ti-author">
                    <div className="ta-pic">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="ta-text">
                      <h5>{testimonial.name}</h5>
                      <span>{testimonial.username}</span>
                    </div>
                  </div>
                  <p>{testimonial.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {isOpen && (
        <ReactImageLightbox
          mainSrc={currentImage}
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default About;
